module.exports = __webpack_public_path__ + "static/img/privacy-img-right.d36f11fd.png";